//LOGO
export const LOGO = '/assets/svg/logo_dark.svg'

//SITE NAME
export const SITE_NAME = 'The Time To Give Network'

export const HEADER_SIDE_PANEL = []

// SIDE PANEL LIST
export const SIDE_PANEL = [
    {
        label: 'Home',
        path: '/dashboard',
        type: 'single',
    },
    // {
    //     label: 'ERP',
    //     path: '/erp',
    //     type: 'pseudoMultiple',
    //     subLinks: [
    //         {
    //             label: 'Draft Auctions ',
    //             path: '/erp/auction/draft',
    //         },
    //         {
    //             label: 'Active Auctions',
    //             path: '/erp/auction/open',
    //         },
    //         {
    //             label: 'Closed Auctions',
    //             path: '/erp/auction/closed',
    //         },
    //         {
    //             label: 'All Auctions',
    //             path: '/erp/auction/all',
    //         },
    //     ],
    // },
    // {
    //     label: 'Schedule Pickup',
    //     path: '/appointment/all',
    //     type: 'single',
    // },
    {
        label: 'Support',
        path: '/subscribers',
        type: 'single',
    },
    {
        label: 'IOI Approval',
        path: '/ioi_request',
        type: 'single',
    },
    {
        label: 'Invoice',
        path: 'invoice',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/invoice/all',
            },
            {
                label: 'Unpaid',
                path: '/invoice/unpaid',
            },
            {
                label: 'Paid',
                path: '/invoice/paid',
            },
            {
                label: 'Cancel',
                path: '/invoice/cancel',
            },
        ],
    },
    {
        label: 'Offering',
        type: 'multiple',
        path: 'listing',
        subLinks: [
            {
                label: 'Active',
                path: '/listing/open',
                showCount: true,
                count_name: 'activeCount',
            },
            {
                label: 'Sold',
                path: '/listing/sold',
                showCount: true,
                count_name: 'soldCount',
            },
            {
                label: 'Unsold',
                path: '/listing/unsold',
                showCount: true,
                count_name: 'unsoldCount',
            },
            {
                label: 'Draft',
                path: '/listing/draft',
                showCount: true,
                count_name: 'draftCount',
            },
            {
                label: 'Relisted',
                path: '/listing/relisted',
            },
        ],
    },

    {
        label: 'TimeBidder',
        path: 'users',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/users/all',
            },
            {
                label: 'Active',
                path: '/users/active',
            },
            {
                label: 'Unverified',
                path: '/users/unverified',
            },
            {
                label: 'Deactivated',
                path: '/users/deactivate',
            },
            {
                label: 'Restricted',
                path: '/users/rejected',
            },
        ],
    },
    {
        label: 'TimeGiver',
        path: 'org',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/org/all',
            },
            {
                label: 'Active',
                path: '/org/active',
            },
            {
                label: 'Deactivate',
                path: '/org/deactivate',
            },
            {
                label: 'Restricted',
                path: '/org/rejected',
            },
        ],
    },
    {
        label: 'Agencies',
        path: '/agency',
        type: 'multiple',
        subLinks: [
            {
                label: 'All Agencies',
                path: '/agency/all',
            },
            {
                label: 'Agency Users',
                path: '/agency/users/all',
                // dynamicPaths: true,
            },
            {
                label: '',
                path: '/agency/users/edit',
                subType: 'User Edit',
                dynamicPaths: true,
            },
            {
                label: 'Payment Received',
                path: '/agency/payment',
            },
            {
                label: '',
                path: '/agency/new',
                subType: 'Add',
                dynamicPaths: true,
            },
            {
                label: '',
                path: '/agency/edit',
                subType: 'Edit',
                dynamicPaths: true,
            },
        ],
    },

    // {
    //     label: 'Marketing',
    //     path: 'campaign',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Create Campaign ',
    //             path: '/campaign/create',
    //         },
    //         {
    //             label: 'Email template',
    //             path: '/campaign/template',
    //         },
    //     ],
    // },
    {
        label: 'Communications',
        path: 'communications',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email Template',
                path: '/communications/email',
            },
            {
                label: 'SMS Template',
                path: '/communications/sms',
            },
        ],
    },
    {
        label: 'Online Store',
        path: 'store',
        type: 'multiple',
        subLinks: [
            {
                label: 'Themes',
                path: '/store/themes',
            },
            {
                label: 'Store Configuration',
                path: '/store/configuration',
            },
        ],
    },
    // {
    //     label: 'Plugins',
    //     path: '/plugins',
    //     type: 'single',
    // },
    {
        label: 'Settings',
        path: 'settings',
        type: 'multiple',
        subLinks: [
            {
                label: 'Static Pages',
                path: '/settings/static',
            },
            // {
            //     label: 'Banner Image',
            //     path: '/settings/banner',
            // },
            {
                label: 'Pallet Pricing',
                path: '/settings/palletPricing',
            },
            {
                label: 'FAQ',
                path: '/settings/faq',
            },
            // {
            //     label: 'Category',
            //     path: '/settings/category',
            // },
            // {
            //     label: 'Condition',
            //     path: '/settings/condition',
            // },
            {
                label: 'Location',
                path: '/settings/location',
            },
            {
                label: 'General Settings',
                path: '/settings/general',
            },
            {
                label: 'Maintanence',
                path: '/settings/maintanence',
            },

            {
                label: 'Bid Increments',
                path: '/settings/bid_increments',
            },
            {
                label: 'Tax Code',
                path: '/settings/tax_code',
            },

            {
                label: 'UI Settings',
                path: '/ui_settings',
            },
            {
                label: 'Language Manager',
                path: '/languageManager',
            },
            // {
            //     label: 'Subscribers',
            //     path: '/subscribers',
            // },
            {
                label: 'Change Password',
                path: '/change_password',
            },
            {
                label: 'Two Factor Authentication',
                path: '/settings/twoFactor',
            },
        ],
    },
    // {
    //     label: 'Auctions',
    //     path: 'auction',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Active',
    //             path: '/auction/open',
    //         },
    //         {
    //             label: 'Upcoming',
    //             path: '/auction/upcomming',
    //         },
    //         {
    //             label: 'Draft',
    //             path: '/auction/draft',
    //         },
    //         {
    //             label: 'Past',
    //             path: '/auction/closed',
    //         },
    //     ],
    // },
    // {
    //     label: 'Video Auction',
    //     path: 'videoAuction',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Broadcast',
    //             path: '/videoAuction/broadcast',
    //         },
    //         {
    //             label: 'Live Auctions',
    //             path: '/videoAuction/live_auction',
    //         },
    //     ],
    // },

    {
        label: 'Employee',
        path: 'employees',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/employees/all',
            },
        ],
    },
    {
        label: 'Analytics',
        path: 'report',
        type: 'multiple',
        subLinks: [
            {
                label: 'Report',
                path: '/report',
                type: 'single',
            },
        ],
    },

    // {
    //     label: 'My Billing Info',
    //     path: 'billing',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Payment',
    //             path: '/billing/all/0',
    //         },
    //         {
    //             label: 'Paid Invoice',
    //             path: '/billing/paid',
    //         },
    //         {
    //             label: 'Unpaid Invoice',
    //             path: '/billing/unpaid',
    //         },
    //     ],
    // },
    // {
    //     label: 'Template',
    //     type: 'multiple',
    //     path: 'templates',
    //     subLinks: [
    //         {
    //             label: 'Listing',
    //             path: '/templates/listing',
    //         },
    //         {
    //             label: 'Auction',
    //             path: '/templates/auction',
    //         },
    //     ],
    // },
    {
        label: 'Transactions',
        path: 'transaction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Payment',
                path: '/transaction/payment',
            },
        ],
    },
    // {
    //     label: 'Return',
    //     path: 'return',
    //     type: 'multiple',
    //     subLinks: [
    //         // {
    //         //     label: 'Pending',
    //         //     path: '/return/pending',
    //         // },
    //         {
    //             label: 'Completed',
    //             path: '/return/completed',
    //         },
    //     ],
    // },
    // {
    //     label: 'Order Control',
    //     path: 'ordercontrol',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'New',
    //             path: '/ordercontrol/new',
    //         },
    //         {
    //             label: 'In Transit',
    //             path: '/ordercontrol/intransit',
    //         },
    //         {
    //             label: 'Ready for Pickup',
    //             path: '/ordercontrol/pickup',
    //         },
    //         {
    //             label: 'Completed Order',
    //             path: '/ordercontrol/completed',
    //         },
    //         {
    //             label: 'Cancelled',
    //             path: '/ordercontrol/cancelled',
    //         },
    //         {
    //             label: 'Pending',
    //             path: '/ordercontrol/undelivered',
    //         },
    //         // {
    //         //     label: 'Delivered',
    //         //     path: '/ordercontrol/delivered',
    //         // },
    //     ],
    // },
    // {
    //     label: 'Inventory',
    //     path: 'inventory',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Add Inventory',
    //             path: '/inventory/add',
    //         },
    //         {
    //             label: 'Active Inventory',
    //             path: '/inventory/active',
    //         },
    //     ],
    // },
    {
        label: 'Logs',
        path: 'logs',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email',
                path: '/logs/emailLogs',
            },
            {
                label: 'SMS',
                path: '/logs/smsLogs',
            },
        ],
    },
    // {
    //     label: 'Questions & Answers',
    //     path: '/questions_answers',
    //     type: 'single',
    //     showCount: true,
    //     count_name: 'noReplyCount',
    // },

    // {
    //     label: 'Messages',
    //     path: '/messages',
    //     type: 'single',
    // },

    // {
    //     label: 'Dynamic Pages',
    //     path: 'return',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Dynamic Fields',
    //             path: '/dynamic/pages',
    //             type: 'single',
    //         },
    //         {
    //             label: 'Dynamic Tables',
    //             path: '/dynamic/table/pages',
    //             type: 'single',
    //         },
    //     ],
    // },
]

export const ALL_PAGINATION = [
    {
        value: '20',
        show: '20 Results per page',
    },
    {
        value: '40',
        show: '40 Results per page',
    },
    {
        value: '60',
        show: '60 Results per page',
    },
]
